<template>
  <nav>
    <h2>Allotments</h2>
    <menu>
      <NavLink :to="{ name: 'allotments-overview' }" label="Overview" icon="list" tooltip="Allotments Overview" />
      <NavLink :to="{ name: 'allotments-overview', query: { upload: null }}" label="Upload" icon="file_upload" tooltip="Allotments Upload" />
      <NavLink to="/allotments/financial-overview" label="Financial overview" icon="euro" tooltip="Allotments Financial overview" />
      <NavLink to="/allotments/change-approvals" :notifications="pendingApprovalsCount ?? undefined" label="Approve changes" icon="check_circle" tooltip="Allotments Change approvals" />
      <NavLink to="/allotments/evolution" label="Evolution" icon="timeline" tooltip="Allotments Evolution" />
    </menu>

    <h2 v-if="isAdmin && featureFlags.dashboardApp">Dashboard</h2>
    <menu v-if="isAdmin && featureFlags.dashboardApp">
      <NavLink to="/dashboard/files" label="Files" icon="list" tooltip="Files Overview" />
    </menu>

    <h2>Passengers</h2>
    <menu>
      <NavLink to="/passenger-data" label="Overview" icon="history" tooltip="Passengers Overview" />
      <NavLink :to="{ name: 'passengerData', query: { upload: null }}" label="Upload" icon="upload" tooltip="Passengers Upload" />
    </menu>

    <h2>Flight Search</h2>
    <menu>
      <NavLink to="/search-flights" label="Search for flights" icon="search" tooltip="Search for flights" />
      <NavLink to="/purchase-overview" label="Purchase overview" icon="list" tooltip="Purchase overview" />
    </menu>

    <h2>Fares</h2>
    <menu>
      <NavLink to="/fares" label="Overview" icon="list" tooltip="Fares Overview" />
      <NavLink :to="{ name: 'fares', query: { upload: null }}" label="Upload" icon="file_upload" tooltip="Fares Upload" />
    </menu>

    <h2>Reports</h2>
    <menu>
      <NavLink to="/reports/generate" label="Generate report" icon="analytics" tooltip="Generate Reports"/>
      <NavLink to="/reports" label="Overview" icon="history" tooltip="Reports Overview" />
    </menu>

    <h2>Admin</h2>
    <menu>
      <NavLink to="/admin/users" label="User Management" icon="group" tooltip="Admin User Management" />
      <NavLink to="/admin/reference-data" label="Reference data" icon="list" tooltip="Admin Reference data" />
      <NavLink to="/admin/audit" label="Audit log" icon="history" tooltip="Admin Audit log" />
      <NavLink to="/admin/business-rules" label="Business rules" icon="psychology" tooltip="Admin Business rules" />
    </menu>

  </nav>
</template>
<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentUserStore } from '@/stores/current-user-store.ts';
import NavLink from '@/components/structure/NavLink.vue';
import { featureFlags } from '@/config/feature-flags.ts';
import {useAllotmentsStore} from "@/Features/Allotments/stores/allotment-store.ts";

const allotmentsStore = useAllotmentsStore();
const { count: pendingApprovalsCount } = storeToRefs(allotmentsStore);
const currentUserStore = useCurrentUserStore();
const { isAdmin } = storeToRefs(currentUserStore);
let pendingApprovalsInterval: ReturnType<typeof setInterval> | undefined;

function refreshPendingApprovalsCount(): void {
  void allotmentsStore.getPendingApproval();
}

onMounted(() => {
  refreshPendingApprovalsCount();
  pendingApprovalsInterval = setInterval(refreshPendingApprovalsCount, 60_000);
});

onUnmounted(() => {
  if (pendingApprovalsInterval) {
    clearInterval(pendingApprovalsInterval);
  }
});
</script>
